import { useParams } from "react-router-dom";
import ApiKeysIconSvg from "assets/api-key.svg?react";
import DestinationsIconSvg from "assets/destination.svg?react";
import GeneralIconSvg from "assets/general.svg?react";
import ProviderAppsIconSvg from "assets/provider-apps.svg?react";
import SettingsIconSvg from "assets/settings.svg";

import { SidebarLayout } from "../SidebarLayout";

const GeneralIconSvgComponent = () => {
  return <GeneralIconSvg width={24} height={24} />;
};

const ProviderAppsIconSvgComponent = () => {
  return <ProviderAppsIconSvg width={24} height={24} />;
};

const DestinationsIconSvgComponent = () => {
  return <DestinationsIconSvg width={24} height={24} />;
};

const ApiKeysIconSvgComponent = () => {
  return <ApiKeysIconSvg width={24} height={24} />;
};

export const SettingsSection = () => {
  const { projectId } = useParams();
  return (
    <SidebarLayout.SidebarMainLayout.SidebarSection
      title="Project Settings"
      alt="settings"
      iconSrc={SettingsIconSvg}
    >
      <SidebarLayout.SidebarMainLayout.ListNavLink
        to={`/projects/${projectId}/settings`}
        label="General"
        iconSvg={<GeneralIconSvgComponent />}
      />
      <SidebarLayout.SidebarMainLayout.ListNavLink
        to={`/projects/${projectId}/provider-apps`}
        label="Provider apps"
        iconSvg={<ProviderAppsIconSvgComponent />}
      />
      <SidebarLayout.SidebarMainLayout.ListNavLink
        to={`/projects/${projectId}/destinations`}
        label="Destinations"
        iconSvg={<DestinationsIconSvgComponent />}
      />
      <SidebarLayout.SidebarMainLayout.ListNavLink
        to={`/projects/${projectId}/api-keys`}
        label="API keys"
        iconSvg={<ApiKeysIconSvgComponent />}
      />
    </SidebarLayout.SidebarMainLayout.SidebarSection>
  );
};
